(() => {
 const start = () => {
 if (document.documentElement.dataset.holdcomApp !== 'true') return;

(() => {
  if (!['holdcom.com.au', 'www.holdcom.com.au'].includes(location.hostname)) return;
  if (window.__holdcomWebsiteAppVisibilityInstalled) return;
  window.__holdcomWebsiteAppVisibilityInstalled = true;


  const isDownloadPage = (url) =>
    ['holdcom.com.au', 'www.holdcom.com.au'].includes(url.hostname) &&
    /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/pages\/(?:mobile-apps|phone-apps)\/?$/i.test(url.pathname);
  const isOwnStoreListing = (url) =>
    (url.hostname === 'apps.apple.com' && /\/id6476811427\/?$/.test(url.pathname)) ||
    (url.hostname === 'play.google.com' &&
      url.pathname === '/store/apps/details' &&
      url.searchParams.get('id') === 'com.holdcom.autoparts.holdcom');

  const style = document.createElement('style');
  style.textContent = `
    [data-holdcom-app-hidden] { display: none !important; }
    html[data-holdcom-app-download-page] main > :not(#holdcom-app-installed),
    html[data-holdcom-app-download-page] #MainContent > :not(#holdcom-app-installed) {
      display: none !important;
    }
    #holdcom-app-installed { padding: 48px 20px; text-align: center; }
  `;
  document.head.appendChild(style);

  const refresh = () => {
    document.querySelectorAll('a[href]:not([data-holdcom-app-hidden])').forEach(link => {
      try {
        const url = new URL(link.getAttribute('href'), location.href);
        if (isDownloadPage(url) || isOwnStoreListing(url)) {
          link.setAttribute('data-holdcom-app-hidden', '');
        }
      } catch (_) {}
    });
    document.querySelectorAll('.holdcom-app-downloads:not([data-holdcom-app-hidden])')
      .forEach(block => block.setAttribute('data-holdcom-app-hidden', ''));

    const onDownloadPage = isDownloadPage(new URL(location.href));
    if (onDownloadPage) {
      if (!document.documentElement.hasAttribute('data-holdcom-app-download-page')) {
        document.documentElement.setAttribute('data-holdcom-app-download-page', '');
      }
      const main = document.querySelector('main#MainContent, main, #MainContent');
      if (main && !document.getElementById('holdcom-app-installed')) {
        const message = document.createElement('div');
        message.id = 'holdcom-app-installed';
        const heading = document.createElement('h1');
        heading.textContent = 'You’re already using the HOLDCOM app.';
        const shop = document.createElement('a');
        shop.href = '/';
        shop.textContent = 'Continue shopping';
        message.append(heading, shop);
        main.appendChild(message);
      }
    } else {
      document.documentElement.removeAttribute('data-holdcom-app-download-page');
      document.getElementById('holdcom-app-installed')?.remove();
    }
  };
  refresh();
  new MutationObserver(refresh).observe(document.body, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['href']
  });
  window.addEventListener('popstate', refresh);
})();

 };
 start();
 new MutationObserver(start).observe(document.documentElement, {attributes:true, attributeFilter:['data-holdcom-app']});
})();
